<template>
  <div class="mc-report-view__table">
    <div class="row">
      <!-- Search -->
      <div class="col-md-12">
        <div class="mc-table-view">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end float-end">
            <label class="
                d-inline-flex
                align-items-center
                mc-table-view__search
              ">
              <i class="mc-fa fas fa-search"></i>
              <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'"
                class="ms-2"></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-card>
            <b-skeleton-table :rows="3" :columns="fields.length" :table-props="{ bordered: false, striped: true }">
            </b-skeleton-table>
          </b-card>
        </template>
        <b-table class="datatables" :items="listData" :fields="fields"
          responsive="md" show-empty :empty-text="$t('global.emptyTable')" :per-page="perPage" :empty-filtered-text="$t('global.emptyFilteredTable')"
          :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
          <template #cell(totalDistance)="data">
            {{ minimizeFloat(data.item.totalDistance) }}
          </template>

          <template #cell(totalTimeTrip)="data">
            {{ data.item.totalTimeTripFormatted }}
          </template>

          <template #cell(totalTimeTripStop)="data">
            {{ data.item.totalTimeTripStopFormatted }}
          </template>

          <template #cell(fuelEficiency)="data">
            {{ minimizeFloat(data.item.fuelEficiency) }}
          </template>

          <template #cell(totalEficiency)="data">
            {{ minimizeFloat(data.item.totalEficiency) }}
          </template>

          <template #cell(averageSpeed)="data">
            {{ minimizeFloat(data.item.averageSpeed) }}
          </template>
        </b-table>
      </b-skeleton-wrapper>
    </div>
    <div class="row mt-3" v-if="fields.length > 0">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Menampilkan
            <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions">
            </b-form-select>
            entri. <p>Menampilkan <strong>{{ filteredItems.length > 0 ? ((currentPage - 1) * perPage + 1) : 0 }}</strong> - <strong>{{ Math.min(filteredItems.length, (currentPage * perPage)) }}</strong> dari <strong>{{ filteredItems.length }}</strong></p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows" :per-page="perPage"></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_REPORT_MANAGEMENT_VEHICLE } from "@/services/api/report/report"
import moment from "moment";
import { Helper } from "@/mixin/helper";
import { Export } from "@/mixin/export";
import { EXPORT_EXCEL_REPORT_MANAGEMENT_VEHICLE } from "@/services/api/report/excel";
import { EXPORT_PDF_REPORT_MANAGEMENT_VEHICLE } from "@/services/api/report/pdf";
moment.locale("id");

export default {
  name: "VehicleManagementTable",
  mixins: [Helper, Export],
  data() {
    return {
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      reportManagementVehicle: {
        reportManagementVehicle: []
      },
      fields: [],
      isLoading: false,
      fileName: '',
      openSection: false,
      periode: [],
      filteredItems: []
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.reportManagementVehicle.reportManagementVehicle.length;
    },
    listData() {
      return this.reportManagementVehicle.reportManagementVehicle;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.reportManagementVehicle.reportManagementVehicle.length;
  },
  methods: {
    /**
     * Search the table data with search input
     */

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    refreshData(periode, filter, fields) {
      this.fields = fields;
      this.isLoading = true;
      this.periode = periode;
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter
        }
      }

      var filterVar = {
        startDate: periode[0],
        endDate: periode[1],
        ...filters
      };

      var self = this;
      var getData = this.$apollo
        .query({
          query: GET_REPORT_MANAGEMENT_VEHICLE,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: 'no-cache'
        }).then(res => {
          var data = res.data;
          self.totalRows = data.reportManagementVehicle.reportManagementVehicle.length;
          if (data.reportManagementVehicle.reportManagementVehicle.length === 0) {
            self.reportManagementVehicle.reportManagementVehicle = [];
            self.isLoading = false;
            return [];
          }
          self.isEmpty = false;

          self.reportManagementVehicle.reportManagementVehicle = data.reportManagementVehicle.reportManagementVehicle;
          self.filteredItems = data.reportManagementVehicle.reportManagementVehicle;

          self.isLoading = false;
        })

      return getData;
    },

    openTable(periode, filter, fields) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.refreshData(periode, filter, fields);
          this.openSection = false;
        }, 500);
      })
    },

    downloadToExcel(periode, filter, fields) {
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter
        }
      }
      var filterVar = {
        startDate: periode[0],
        endDate: periode[1],
        column: fields.map(item => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(periode[1])}`,
        ...filters
      };

      var downloadProgress = {
        name : 'Manajemen Kendaraan ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY")+'.xlsx',
        periode : moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt : moment().format('DD MMM YYYY HH:mm:ss'),
        percentage : 0,
        type : 'excel'
      };
      this.$store.commit("report/saveProgress", downloadProgress);
      
      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if(percentage< 75) {
          percentage += 25;
        }else if(percentage== 75) {
          percentage = 90;
        }else if(percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: percentage});
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_EXCEL_REPORT_MANAGEMENT_VEHICLE,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: 'no-cache'
        }).then(res => {
          var isSuccessful = res.data.excelReportManagementVehicle.isSuccessful;
          if(isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 100});
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 90});
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        })
    },

    downloadToPdf(periode, filter, fields) {
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter
        }
      }
      var filterVar = {
        startDate: periode[0],
        endDate: periode[1],
        column: fields.map(item => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(periode[1])}`,
        ...filters
      };

      var downloadProgress = {
        name : 'Manajemen Kendaraan ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY")+'.pdf',
        periode : moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt : moment().format('DD MMM YYYY HH:mm:ss'),
        percentage : 0,
        type : 'pdf'
      };
      this.$store.commit("report/saveProgress", downloadProgress);
      
      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if(percentage< 75) {
          percentage += 25;
        }else if(percentage== 75) {
          percentage = 90;
        }else if(percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: percentage});
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_PDF_REPORT_MANAGEMENT_VEHICLE,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: 'no-cache'
        }).then(res => {
          var isSuccessful = res.data.pdfReportManagementVehicle.isSuccessful;
          if(isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 100});
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {progress: downloadProgress, percentage: 90});
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        })
    }
  },
};
</script>